module.exports = __webpack_public_path__ + "img/Frame-4.6fab1681.svg";